import { render } from "./CompanyInternFeedback.vue?vue&type=template&id=406ca4f6"
import script from "./CompanyInternFeedback.vue?vue&type=script&lang=js"
export * from "./CompanyInternFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__